import { useState } from 'react'

import { ReactComponent as AlternateFolderIcon } from 'assets/icons/folder16.svg'
import { Button } from 'components/Button'
import { FolderIcon } from 'components/Icons/FolderIcon'
import ActionModal, { SubmitProps } from 'components/NavRightClickMenu/components/ActionModal/ActionModal'
import { Tooltip } from 'components/Tooltip/Tooltip'

import Styles from './CopyLocationPicker.module.scss'
import { useBrand } from 'hooks/useBrand'

export interface CopyLocationPickerProps {
  alternateButton?: boolean
  disableRoot: boolean
  hidePopover?: boolean
  destination: SubmitProps | undefined
  onDestinationChange: (destination: SubmitProps) => void
}

export const CopyLocationPicker = ({
  disableRoot,
  destination,
  onDestinationChange: setDestination,
  alternateButton,
  hidePopover,
}: CopyLocationPickerProps) => {
  const [destinationModalVisible, setDestinationModalVisible] = useState(false)
  const { defaultFoldersLocation } = useBrand()

  const handleButtonPress = () => {
    setDestinationModalVisible(true)
  }
  const handleDestinationModalVisibility = (visibility: boolean) => {
    setDestinationModalVisible(visibility)
  }

  const handleFolderSelection = (destination: SubmitProps) => {
    setDestinationModalVisible(false)
    setDestination(destination)
  }

  const destinationName = destination?.selectedFolder?.title || defaultFoldersLocation

  return (
    <>
      {alternateButton ? (
        <Button
          variant="tertiaryGreen"
          onPress={handleButtonPress}
          size="md"
          frontIcon={AlternateFolderIcon}
          className={Styles.alternateButton}
        >
          <span>{destinationName}</span>
        </Button>
      ) : (
        <div className={Styles.container}>
          <span className={Styles.text}>Location</span>
          <Tooltip label="Change location" placement="bottom" className={Styles.tooltip}>
            <div>
              <Button variant="secondary" size="md" className={Styles.folderButton} onPress={handleButtonPress}>
                <FolderIcon />
                <span className={Styles.folderButtonText}>{destinationName}</span>
              </Button>
            </div>
          </Tooltip>
        </div>
      )}
      {destinationModalVisible && (
        <ActionModal
          titleText={'Pick a location...'}
          visible
          setVisible={handleDestinationModalVisibility}
          currentFolder={destination?.selectedFolder}
          initialFolder={destination?.selectedFolder}
          initialWorkspaceId={destination?.newWorkspaceId}
          selectedFiles={[]}
          disableRoot={disableRoot}
          submit={handleFolderSelection}
          ctaText="Select Location"
          isMove={false}
          hidePopover={hidePopover ?? false}
        />
      )}
    </>
  )
}
